// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { S } from './styles';

interface EpilogueContentProps {
  needRewatch: boolean;
  handleNextModule: () => void;
}

function EpilogueContent(props:EpilogueContentProps):JSX.Element {
  const {
    needRewatch,
    handleNextModule,
  } = props;

  return (
    <S.Container>
      {needRewatch ? (
        <>
          <S.CourseIncompletedImage />
          <S.Message><FormattedMessage id="F018" values={{ br: <br/> }} /></S.Message>
          <S.Button onClick={handleNextModule}><FormattedMessage id="F019" /></S.Button>
        </>
      ) : (
        <>
          <S.CourseCompletedImage />
          <S.Message><FormattedMessage id="F016" values={{ br: <br/> }} /></S.Message>
          <S.Button as={Link} to="/home"><FormattedMessage id="F017" /></S.Button>
        </>
      )}
    </S.Container>
  );
}

export { EpilogueContent as default };
